// a library to wrap and simplify api calls
import Api from "./PhiApi";
import Role from "./PhiRole";

class PhiUser {
    constructor(options, data = {}) {
        this.phiRef = options;

        this.addParent = function* (that, payload) {
            let response = yield Api.addUser(JSON.stringify(payload));

            if (response.ok && response.data && response.data.status === 200 && Boolean(response.data.results[0])) {
                return response.data.results[0];
            } else {
                return { error: response.problem || "Signup Failed" };
            }
        };

        this.sendOtp = function* (that, email) {
            let response = yield Api.sendOtp(email);
            if (response && response.data && response.status === 200) {
                return response.data;
            } else {
                return { error: response.problem || "Email could not be sent at the moment." };
            }
        };

        this.login = function* (that, credentials) {
            let response = yield Api.userLogin(credentials);

            if (response.ok && response.data) {
                let token = { jwt: response.data.jwt, iat: response.data.iat };
                that.phiRef.setSession(token);

                if (response.data.role) {
                    let roles = response.data.role.map((a) => new Role(a));
                    roles.sort(function (a, b) {
                        if (a.role_type_id > b.role_type_id) {
                            return 1;
                        } else {
                            return -1;
                        }
                    });
                    that.phiRef.Storage.setItem("roles", JSON.stringify(response.data.role));
                    that.userRoles = roles;
                }

                let userResponse = yield that.get(that, {
                    profile: true,
                    email: true,
                    phone: true,
                    address: true,
                    custom: true,
                    device: false,
                    customer: false,
                    organization: true,
                });

                if (userResponse && !userResponse.error) {
                    that.userProfile = userResponse.profile;
                    that.userProfile.username = userResponse.profile.username;
                    that.phiRef.Storage.setItem("profile", JSON.stringify(userResponse.profile));
                    that.phiRef.Storage.setItem("custom", JSON.stringify(userResponse.custom));
                    if (userResponse.organization) {
                        that.phiRef.Storage.setItem("organization", userResponse.organization);
                    }
                    return userResponse;
                }
            }
            return response;
        };

        this.socialMediaLogin = function* (that, credentials) {
            let response = yield Api.socialMediaLogin(credentials);

            if (response.ok && response.data) {
                let token = { jwt: response.data.jwt, iat: response.data.iat };
                that.phiRef.setSession(token);

                if (response.data.role) {
                    let roles = response.data.role.map((a) => new Role(a));
                    roles.sort(function (a, b) {
                        if (a.role_type_id > b.role_type_id) {
                            return 1;
                        } else {
                            return -1;
                        }
                    });
                    that.phiRef.Storage.setItem("roles", JSON.stringify(response.data.role));
                    that.userRoles = roles;
                }

                let userResponse = yield that.get(that, {
                    profile: true,
                    email: true,
                    phone: true,
                    address: true,
                    custom: true,
                    device: false,
                    customer: false,
                    organization: true
                });

                if (userResponse && !userResponse.error) {
                    that.userProfile = userResponse.profile;
                    that.userProfile.username = userResponse.profile.username;
                    that.phiRef.Storage.setItem("profile", JSON.stringify(userResponse.profile));
                    that.phiRef.Storage.setItem("custom", JSON.stringify(userResponse.custom));
                    if (userResponse.organization) {
                        that.phiRef.Storage.setItem("organization", JSON.stringify(userResponse.organization));
                    }
                    return userResponse;
                }
            }
            return response;
        };

        this.magicLinkLogin = function* (that, config) {
            let response = yield Api.magicLinkLogin(config);

            if (response.ok && response.data) {
                let token = { jwt: response.data.jwt, iat: response.data.iat };
                that.phiRef.setSession(token);

                if (response.data.role) {
                    let roles = response.data.role.map((a) => new Role(a));
                    roles.sort(function (a, b) {
                        if (a.role_type_id > b.role_type_id) {
                            return 1;
                        } else {
                            return -1;
                        }
                    });
                    that.phiRef.Storage.setItem("roles", JSON.stringify(response.data.role));
                    that.userRoles = roles;
                }

                let userResponse = yield that.get(that, {
                    profile: true,
                    email: true,
                    phone: true,
                    address: true,
                    custom: true,
                    device: false,
                    customer: false,
                    organization: true,
                });

                if (userResponse && !userResponse.error) {
                    that.userProfile = userResponse.profile;
                    that.userProfile.username = userResponse.profile.username;
                    that.phiRef.Storage.setItem("profile", JSON.stringify(userResponse.profile));
                    that.phiRef.Storage.setItem("custom", JSON.stringify(userResponse.custom));
                    if (userResponse.organization) {
                        that.phiRef.Storage.setItem("organization", userResponse.organization);
                    }
                    return userResponse;
                }
            }
            return response;
        };

        this.handleLoginUsingInvitationLink = function* (that, config) {
            let response = yield Api.invitationLinkLogin(config);
            if (response.ok && response.data) {
                return response.data
            }
            return response;
        };

        this.logout = function () {
            let storage = this.phiRef.Storage;
            this.phiRef.removeSession();
            storage.clear();
        };

        this.sendOtpPhone = function* (that, params) {
            const response = yield Api.sendOtpPhone(params);
            console.log("send otp response received", response);

            if (response.ok && response.data && response.data.status === 200) {
                return true;
            } else return false;
        };

        this.verifyOtp = function* (that, params) {
            const response = yield Api.verifyOtp(params);
            console.log("verify otp response received", response);

            if (response.ok && response.data && response.data.status === 200) {
                return response.data;
            } else return { error: "OTP verification failed" };
        };

        this.verifyUnRegisteredOtp = function* (that, params) {
            const response = yield Api.verifyUnRegisteredOtp(params);
            console.log("verify otp response received", response);

            if (response.ok && response.data && response.data.results && response.data.results[0]) {
                return response.data.results[0].hsg_verify_unregistered_otp;
            } else {
                return false;
            }
        };

        this.put = function* (that, config) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.updateUser(config);
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results;
                } else {
                    return { error: response.problem };
                }
            }
            return null;
        };

        this.updateSimilarStudents = function* (that, config) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.updateSimilarStudents(config);
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results;
                } else {
                    return { error: response.problem };
                }
            }
            return null;
        };

        this.isAuthenticated = function () {
            let token = this.phiRef.getSession();
            let authenticated = token ? true : false;
            return authenticated;
        };

        this.updateUser = function* (that, params) {
            let response = yield Api.updateUser(params);

            if (response.ok && response.data && response.data.status === 200) {
                return { ok: true };
            } else return { error: response.problem || "Failed to update information" };
        };

        this.isGuest = function () {
            if (this.isAuthenticated) {
                const isGuest = Boolean(parseInt(this.phiRef.Storage.getItem("isGuest")));
                return isGuest;
            } else return false;
        };

        this.isMagicLinkUsed = function () {
            if (this.isAuthenticated) {
                const isMagicLinkUsed = Boolean(parseInt(this.phiRef.Storage.getItem("isMagicLinkUsed")));
                return isMagicLinkUsed;
            } else return false;
        };

        this.parseData = function (result) {
            let user = result;
            user.profile = result.profile ? JSON.parse(result.profile)[0] : {};
            user.role = result.role ? JSON.parse(result.role) : null;
            user.device = result.token ? JSON.parse(result.token) : null;
            user.address = result.address ? JSON.parse(result.address)[0] : null;
            user.email = result.email ? JSON.parse(result.email)[0] : null;
            user.custom = result.custom ? JSON.parse(result.custom)[0] : null;
            user.phone = result.phone ? JSON.parse(result.phone)[0] : null;
            user.customer = result.customer ? JSON.parse(result.customer)[0] : null;
            user.parent_association = result.parent_association ? JSON.parse(result.parent_association) : null;
            user.profile.username = result.username;
            user.profile.uuid = result.uuid;
            return user;
        };

        this.get = function* (that, config) {
            let token = that.phiRef.getSession();
            if (token) {
                let response = yield Api.getUser(config);

                if (!response.ok) return { error: response.problem };

                if (response.data && response.data.results && response.data.results.length > 0) {
                    const userResponse = that.parseData(response.data.results[0]);

                    if (userResponse.role) {
                        let roles = userResponse.role.map((a) => new Role(a));
                        roles.sort(function (a, b) {
                            if (a.role_type_id > b.role_type_id) {
                                return 1;
                            } else {
                                return -1;
                            }
                        });
                        that.phiRef.Storage.setItem("roles", JSON.stringify(userResponse.role));
                        that.userRoles = roles;
                    }

                    that.userProfile = userResponse.profile;
                    that.userProfile.username = userResponse.profile.username;
                    that.phiRef.Storage.setItem("data", JSON.stringify(userResponse));
                    that.phiRef.Storage.setItem("custom", JSON.stringify(userResponse.custom));
                    that.phiRef.Storage.setItem("profile", JSON.stringify(userResponse.profile));
                    that.phiRef.Storage.setItem("organization", userResponse.organization);
                    if (userResponse.organization) {
                        that.phiRef.Storage.setItem("organization", userResponse.organization);
                    }
                    return userResponse;
                } else {
                    return { error: "Invalid response" };
                }
            }
            return null;
        };

        this.roles = function () {
            if (!this.userRoles) {
                let roles = this.phiRef.Storage.getItem("roles");
                if (roles) {
                    roles = JSON.parse(roles);
                    roles = roles.map((a) => new Role(a));
                }
                this.userRoles = roles;
            }
            return this.userRoles;
        };

        this.profile = function () {
            if (!this.userProfile) {
                let profile = this.phiRef.Storage.getItem("profile");
                if (profile) {
                    this.userProfile = JSON.parse(profile);
                }
            }
            return this.userProfile;
        };

        this.uploadUser = function* (that, payload) {
            let token = that.phiRef.getSession();
            if (token) {
                let response = yield Api.uploadUser(payload);
                console.log("Upload Response", response);
                if (response.ok && response.data) {
                    return response;
                }
            }
            return null;
        };

        this.uploadOmr = function* (that, payload, event_track_id) {
            let token = that.phiRef.getSession();
            if (token) {
                let response = yield Api.uploadOmr(payload, event_track_id);
                console.log("Upload Response", response);
                if (response.ok && response.data) {
                    return response;
                }
            }
            return null;
        };

        this.getUserAssociation = function* (that, params) {
            let token = that.phiRef.getSession();
            if (token) {
                const request = {
                    sourceUserId: params.userId,
                    targetUserId: null,
                    relationType: null,
                    email: true,
                    address: true,
                    profile: true,
                    role: true,
                    phone: true,
                    custom: true,
                    device: true,
                    customer: true,
                    organization: true,
                };

                let response = yield Api.getUserAssociation(request);
                if (response.ok && response.data && response.data.status === 200 && Boolean(response.data.results)) {
                    return response.data.results.map((item, pos) => {
                        return that.parseData(item);
                    });
                }
            }
            return null;
        };

        this.putUserAssociation = function* (that, params) {
            let token = that.phiRef.getSession();
            if (token) {
                let response = yield Api.putUserAssociation(params);
                if (response.ok && response.data && response.data.status === 200 && Boolean(response.data.results)) {
                    return true;
                }
            }
            return null;
        };

        this.postUserLinkedInCredentials = function* (that, params) {
            let token = that.phiRef.getSession();
            if (token) {
                let response = yield Api.postUserLinkedInCredentials(params);
                if (response.ok && response.data && response.data.status === 200 && response.data.accessCode) {
                    return {
                        profile: response.data.profile ? JSON.parse(response.data.profile) : null,
                        email: response.data.email ? JSON.parse(response.data.email) : null,
                    };
                }
            }
            return null;
        };

        this.getAvailability = function* (that, config) {
            let token = that.phiRef.getSession();

            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getAvailability(JSON.stringify(config));

                if (response.ok && Boolean(response.data) && response.data.status === 200) {
                    return response.data.results[0];
                } else {
                    return { error: response.problem || "Request failed" };
                }
            } else return { error: "Request failed" };
        };

        //Method is for Checking availabilty Of email,phone,activaitoncode without DOB --- as per New Requirment

        this.getAvailabilityWithoutDOB = function* (that, config) {
            let token = that.phiRef.getSession();

            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getAvailabilityWithoutDOB(JSON.stringify(config));

                if (response.ok && Boolean(response.data) && response.data.status === 200) {
                    return response.data.results[0];
                } else {
                    return { error: response.problem || "Request failed" };
                }
            } else return { error: "Request failed" };
        };

        //Method Ends HERE

        this.addUserAssociationUsingActivationCode = function* (that, config) {
            let token = that.phiRef.getSession();

            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.postUserAssociationUsingActivationCOde(JSON.stringify(config));

                if (response.ok && Boolean(response.data)) {
                    return response.data;
                } else {
                    return { error: response.problem || "Failed to associate child" };
                }
            } else return { error: "Failed to associate child" };
        };

        this.addUserAssociationUsingActivationCodeWithoutDOB = function* (that, config) {
            let token = that.phiRef.getSession();

            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.postUserAssociationUsingActivationCodeWithoutDOB(JSON.stringify(config));

                if (response.ok && Boolean(response.data)) {
                    return response.data;
                } else {
                    return { error: response.problem || "Failed to associate child" };
                }
            } else return { error: "Failed to associate child" };
        };

        this.getParentStudentAssociation = function* (that, params) {
            let token = that.phiRef.getSession();
            if (token) {
                const request = {
                    sourceUserId: params.userId,
                };

                let response = yield Api.getParentStudentAssociation(request);
                if (
                    response.ok &&
                    response.data &&
                    response.data.status === 200 &&
                    response.data.results &&
                    response.data.results.length &&
                    response.data.results[0].association
                ) {
                    return JSON.parse(response.data.results[0].association);
                }
            }
            return null;
        };

        this.postUserInvitationAssociation = function* (that, params) {
            let token = that.phiRef.getSession();
            if (token) {
                let response = yield Api.postUserInvitationAssociation(params);
                if (
                    response.ok &&
                    response.data &&
                    response.data.status === 200 
                ) {
                    return true;
                }
            }
            return null;
        };

        this.fetchUserSignUpStatus = function* (that, config) {
            let token = that.phiRef.getSession();

            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.fetchUserSignUpStatusV3(config.phoneNumber);

                if (response.ok && Boolean(response.data) && response.data.results && response.data.results.length) {
                    return response.data.results[0];
                } else {
                    return { error: "Failed" };
                }
            } else return { error: "Failed" };
        };

        this.makeACall = function* (that, config) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.makeACall(config);
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results;
                } else {
                    return { error: response.problem };
                }
            }
        };

        this.postCovidDeclarationForm = function* (that, payload) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.postCovidDeclarationForm(payload);
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results;
                } else {
                    return { error: response.problem };
                }
            }
        };

        this.getCovidDeclarationList = function* (that, params) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.getCovidDeclarationList(params);
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results;
                } else {
                    return { error: response.problem };
                }
            }
        };

        this.putInvitationRequestSuccess = function* (that, params) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.putInvitationRequestSuccess(params);
            }
        };

        this.postInvitationRequest = function* (that, params) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.postInvitationRequest(params);
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results[0];
                } else {
                    return { error: response.problem };
                }
            }
        };
        this.changeUserLocation = function* (that,params) {
            let token = that.phiRef.getSession();
            if (Boolean(token) && Boolean(token.jwt)) {
                let response = yield Api.postUserLocation(params);
                if (response.ok && response.data && response.data.results && response.data.results.length > 0) {
                    return response.data.results[0];
                } else {
                    return { error: response.problem };
                }
            }
        }

    }
}

export default PhiUser;
